import moment from "moment/min/moment-with-locales";

moment.locale("vi");
export function formatDate(
  date: string | Date | null | undefined,
  format: string = "DD/MM/YYYY"
): string {
  if (date) {
    const momentDate = moment(date);
    if (momentDate.isValid()) {
      return momentDate.format(format);
    }
  }
  return "";
}

export function getDate(date: string | Date | null | undefined): Date | null {
  if (date) {
    const momentDate = moment(date);
    if (momentDate.isValid()) {
      return new Date(momentDate.year(), momentDate.month(), momentDate.date());
    }
  }
  return null;
}

export function formatDateTime(date: string | Date | null | undefined): string {
  if (date) {
    const momentDate = moment(date);
    return momentDate.format("HH:mm DD/MM/YYYY");
  } else return "";
}

export const formValidateRequiredMessage = "Vui lòng nhập vào dữ liệu";
export const formValidateEmailMessage = "Email không đúng định dạng";
export const formValidatePhoneMessage = "Số điện thoại không hợp lệ";

export const formValidateMindMessage = (min: Number) =>
  `Tối thiểu ${min} ký tự`;

export function formatNumber(value: number | string, suf = "", pre = "") {
  if (value) {
    const numValue = Number(value);
    if (isNaN(numValue)) return "0";
    if (pre && numValue < 10) return `${pre}${numValue}`;
    var t = `${numValue.toFixed()}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    if (suf) t += suf;
    return t;
  }
  return "0";
}

export function formatNumberWithDecimals(value: number | string, suf = "", pre = "") {
  if (value) {
    const numValue = Number(value);
    if (isNaN(numValue)) return "0.00";
    if (pre && numValue < 10) return `${pre}${numValue.toFixed(2)}`;
    var t = `${numValue.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    if (suf) t += suf;
    return t;
  }
  return "0.00";
}
export function convertNumber(value: number | string | undefined): number {
  if (value) {
    const numValue = Number(value);
    if (isNaN(numValue)) return 0;
    return numValue;
  }
  return 0;
}

export function getListIndex(
  index: number,
  pageIndex: number,
  pageSize: number
): number {
  return (pageIndex - 1) * pageSize + index + 1;
}
export function getGender(type: number) {
  switch (type) {
    case 1:
      return "Nam";
    case 2:
      return "Nữ";
    default:
      return "---";
  }
}

export function getDateDiff(
  date1: Date | string,
  date2: Date | string
): string {
  if (!date1 || !date2) return "0 ngày";

  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const diff = Math.abs(d2.getTime() - d1.getTime());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  let result = "";
  if (days > 0) result += `${days} ngày `;
  if (hours > 0) result += `${hours} giờ `;
  if (minutes > 0) result += `${minutes} phút`;

  return result.trim() || "0 ngày";
}

export function convertEnumToArray<T extends Record<string, string>>(enumObj: T): { key: string; value: string }[] {
    const seen = new Set<string>();
    return Object.entries(enumObj)
        .filter(([_, value]) => {
            if (seen.has(value)) return false;
            seen.add(value);
            return true;
        })
        .map(([key, value]) => ({ key, value }));
}

export function convertToArray(arr: any[]) {
    return arr.map((item: any) => ({ id: item, name: item }));
}